import { createSlice } from '@reduxjs/toolkit';
import { titleString } from '../constants/Global';
import toProperCase from '../utils/toProperCase';

const initialState = {
  selectedAgency: '',
  selectedState: '',
  agencies: [],
  states: []
};

export enum Directions {
  ASCENDING = 'ascending',
  DESCENDING = 'descending'
}

interface SortConfig {
  key: string;
  direction: Directions;
}

const agencyPincodeSlice = createSlice({
  name: 'agencyPincodeMappingSlice',
  initialState,
  reducers: {
    setSelectedAgency(state, action) {
      state.selectedAgency = action.payload;
    },
    setSelectedState(state, action) {
      state.selectedState = action?.payload;
    },
    setAgencies(state, action) {
      state.agencies = action?.payload;
    },
    setStates(state, action) {
      state.states = action.payload;
    }
  }
});

export const { setSelectedState, setStates, setAgencies, setSelectedAgency } =
  agencyPincodeSlice.actions;
export default agencyPincodeSlice.reducer;
